import { useCallback, useEffect, useState } from 'react';

import { getAdminQueuesOverview, type AdminQueuesOverview } from '../api/admin';

export function useAdminQueues() {
  const [queues, setQueues] = useState<AdminQueuesOverview | null>(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const response = await getAdminQueuesOverview();
      setQueues(response.data.data);
      return response.data.data;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh().catch(() => setQueues(null));
  }, [refresh]);

  return { queues, loading, refresh };
}
